import * as l from "react";
const a = (e) => /* @__PURE__ */ l.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "VU_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ l.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ l.createElement("g", { mask: "url(#VU_svg__a)" }, /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0h32v24H0V0z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v8h32V0H0z",
      fill: "#C51918"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 16v8h32v-8H0z",
      fill: "#5EAA22"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0-2l16.67 14L0 26V-2z",
      fill: "#272727"
    }
  ), /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "VU_svg__b",
      maskUnits: "userSpaceOnUse",
      x: -2,
      y: -8.354,
      width: 36,
      height: 40,
      fill: "#000"
    },
    /* @__PURE__ */ l.createElement("path", { fill: "#fff", d: "M-2-8.354h36v40H-2z" }),
    /* @__PURE__ */ l.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0-3.354L17.408 10H32v4H17.17L0 26.812v-4.471L14 12 0 1.535v-4.89z"
      }
    )
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0-3.354L17.408 10H32v4H17.17L0 26.812v-4.471L14 12 0 1.535v-4.89z",
      fill: "#FFD018"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M17.408 10l-1.218 1.587.539.413h.679v-2zM0-3.354l1.217-1.587L-2-7.41v4.056h2zM32 10h2V8h-2v2zm0 4v2h2v-2h-2zm-14.83 0v-2h-.664l-.532.397L17.17 14zM0 26.812h-2V30.8l3.196-2.385L0 26.812zm0-4.471l-1.188-1.61-.812.6v1.01h2zM14 12l1.188 1.608 2.165-1.599-2.156-1.611L14 12zM0 1.535h-2v1.002l.803.6L0 1.535zm18.625 6.878L1.217-4.94l-2.434 3.173L16.19 11.587l2.435-3.174zM32 8H17.408v4H32V8zm2 6v-4h-4v4h4zm-16.83 2H32v-4H17.17v4zM1.196 28.415l17.17-12.812-2.392-3.206-17.17 12.812 2.392 3.206zM-2 22.34v4.471h4v-4.471h-4zm14.812-11.95l-14 10.34 2.376 3.218 14-10.34-2.376-3.217zm-14.01-7.254l14 10.465 2.396-3.203-14-10.466-2.395 3.204zM-2-3.354v4.889h4v-4.89h-4z",
      fill: "#272727",
      mask: "url(#VU_svg__b)"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M4.874 16.768l.002-1.58c1.409-.31 2.342-.715 2.796-1.201 1.118-1.378.375-4.607-1.923-4.586-1.138 0-2.315.542-2.315 1.819 0 1.585.326 2.263 1.442 2.263 1.11 0 1.516.06 2.247-.936l.792.245c-.782 1.067-1.838 1.91-3.04 1.91-1.982 0-3.06-1.495-3.06-3.222 0-2.134 1.731-3.627 3.82-3.627 1.557 0 4.021 1.908 4.021 3.627 0 1.718 0 2.507-1.351 3.708-.544.483-1.893 1.347-3.43 1.58z",
      fill: "#FFD018"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.992 9.88a.143.143 0 00-.174.101l-.055.208a58.687 58.687 0 01-.137.29l-.164.152a.143.143 0 00.194.21l.145-.134.25.328-.275.147a.143.143 0 10.136.251l.312-.167.214.286-.374.201a.143.143 0 10.135.252l.41-.22c.11.149.205.282.287.399l-.262.14a.143.143 0 10.135.252l.29-.156c.121.18.184.289.184.317a.143.143 0 10.285 0c0-.072-.075-.224-.232-.468a.138.138 0 00.007-.013l.211-.465a.143.143 0 10-.26-.118l-.145.318c-.09-.13-.195-.276-.316-.44l.15-.332a.143.143 0 10-.26-.118l-.084.187a53.114 53.114 0 00-.145-.194l.203-.446a.143.143 0 00-.26-.118l-.139.305a86.908 86.908 0 00-.275-.36l.11-.42a.143.143 0 00-.1-.175z",
      fill: "#FFD018"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.953 9.88a.143.143 0 01.175.101l.055.208.008-.011a.143.143 0 11.226.174l-.098.128.164.151a.143.143 0 01-.193.21l-.145-.134-.25.328.274.147a.143.143 0 11-.135.251l-.313-.167-.214.286.375.201a.143.143 0 11-.135.252l-.41-.22c-.11.149-.206.282-.288.399l.262.14a.143.143 0 11-.135.252l-.29-.156c-.12.18-.183.289-.183.317a.143.143 0 11-.286 0c0-.072.075-.224.232-.468a.136.136 0 01-.006-.013l-.212-.465a.143.143 0 11.26-.118l.145.318c.09-.13.195-.276.316-.44l-.15-.332a.143.143 0 11.26-.118l.084.187.145-.194-.202-.446a.143.143 0 01.26-.118l.138.305.276-.36-.112-.42a.143.143 0 01.102-.175z",
      fill: "#FFD018"
    }
  ))
), t = a;
export {
  t as default
};
